import React from 'react';
import Box from '@mui/material/Box';
import '../assests/css/style.css';
import { FindCareModule } from '@premkumarmph/find-care';
import { GET_AFFILIATE_LOGO_URL } from '../services/PriceTransparencyQueries/PriceTransparencyService';
import { useQuery } from '@apollo/client';
import '../assests/css/style.css';

const BASE_URL = process.env.REACT_APP_API_HOST;
const API_PATH = process.env.REACT_APP_API_PATH;

const COMPLETE_URL = BASE_URL + API_PATH;
const affiliateDnsName = window.location.href.split('/')[2].split('-')[0];


export const BacShoppingModule = () => {
  
  sessionStorage.setItem('FROM_ENTERPRISE', true);
  sessionStorage.setItem('BAC_SHOPPING_EXP', true);
  sessionStorage.setItem('FINDCARE_URL', COMPLETE_URL);

  const [token, subscriberId] = window.location.href
    .split('?token=')[1]
    .split('&subscriberId=');

  const { data: imageUrl } = useQuery(GET_AFFILIATE_LOGO_URL, {
    variables: { affiliateDnsName: affiliateDnsName },
  });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          backgroundColor: '#fff',
        }}>
        <Box
          component="img"
          alt="Partner image"
          sx={{ height: '80px', margin: '10px' }}
          src={imageUrl?.getAffiliateLogoURLUnauth?.imageUrl}
        />
      </Box>
      <Box sx={{ padding: '0px 40px' }}>
        <FindCareModule
          token={token}
          subscriberId={subscriberId}
          URL={COMPLETE_URL}
          path={window.location.pathname}
          hidePartnerList={true}
          hideInNetwork={true}
          fromEnterprise={true}
        />
      </Box>
    </Box>
  );
};
